<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsLink',
  
})
</script>
<template>
  <t-link
    theme="primary"
    class="tlbs-link"
    :href="href"
    :target="target"
    @click="onClick"
  >
    {{ text }}
  </t-link>
</template>

<script setup lang="ts" name="TlbsLink">
import { navigateTo } from '@tlbs/galaxy-sdk';

interface Props {
  link: string,
  text: string;
  target?: string;
  params?: LooseObject[] | null;
}

const props = withDefaults(defineProps<Props>(), {
  link: '',
  text: '',
  target: '_self',
  params: null,
});
const isAbsolutePath = ref(false);
const path = ref('');
const paramObj = ref<LooseObject | undefined>({});
const href = ref('');
watchEffect(() => {
  const url = ref(props.link);
  url.value = url.value.trim();

  // URL 构造函数不支持 '//xxx.com' 的格式,此处做兼容
  if (url.value.indexOf('//') === 0) {
    url.value = location.protocol + url.value;
  }

  // "proto:" 或 "//" 起头的是绝对路径
  isAbsolutePath.value = /^(?:[a-z]+:)/i.test(url.value);


  let urlObj: URL;
  let baseUrl = '';
  if (!isAbsolutePath.value) {
    // 相对地址为了能够被URL对象识别，需要增加协议前缀
    baseUrl = location.origin && location.origin !== 'null'
      ? location.origin
      : 'https://';
  }
  try {
    urlObj = new URL(url.value, baseUrl || undefined);
    // 添加新参数
    props.params?.forEach((item) => {
      urlObj.searchParams.append(item.key, item.value);
    });

    href.value = urlObj.href;
    path.value = urlObj.pathname;

    for (const [key, value] of urlObj.searchParams) {
      if (!paramObj.value) {
        paramObj.value = {};
      }
      paramObj.value[key] = value;
    }

    // 相对地址去掉前缀域名
    if (!isAbsolutePath.value) {
      href.value = urlObj.pathname + urlObj.search + urlObj.hash;
      href.value = href.value.slice(href.value.indexOf('?') + 1);
    }
  } catch (e) {
    // 非法 url时， 直接透传，不再处理
    isAbsolutePath.value = true;
    href.value = url.value;
    path.value = '';
    paramObj.value = props.params?.reduce((p, x) => {
      p[x.key] = x.value;
      return p;
    }, {});
  }
});

const onClick = (e: Event) => {
  // 非绝对路径时，按照页面ID来判断跳转
  if (!isAbsolutePath.value) {
    e.preventDefault();
    navigateTo({
      pageId: path.value, // 页面 Id
      params: paramObj.value,
      target: props.target,
    });
  }
};

</script>
